import React from "react";
import PartnerTypesTable from "./partner-types-table/partner-types-table";
import { ContentContainer } from "../../../components/layout";
import { Divider } from "primereact/divider";
import { Card } from "primereact/card";
export default function PartnerTypes() {
	return (
		<ContentContainer containerTitle="Partner Types">
			{/* <p className="mb-2">
				(<b className="text-red-500">*</b>) - <b>Required fields</b>
			</p> */}
			<PartnerTypesTable />
		</ContentContainer>
	);
}

// * Fix when you add new item in table you cannot edit it nor click it. Find the cause of that bug
